<template>
  <el-dialog
    width="600px"
    :title="businessNo"
    :visible.sync="visible"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="onlineContact"
  >
    <div ref="msgBox" class="chatLogs" @scroll="onScroll">
      <div v-if="loading" class="loading">
        <i class="el-icon-loading" />
      </div>
      <el-row
        v-for="(item, index) in msgList"
        :key="index"
        :class="{
          otherTxt: item.userNo != sendUserNo,
          selfTxt: item.userNo == sendUserNo,
        }"
        class="clearfix"
      >
        <el-col :span="12" :offset="item.userNo == sendUserNo ? 12 : 0">
<!--          <div class="userHead">-->
<!--            <img-->
<!--              v-if="item.userNo == sendUserNo"-->
<!--              src="../assets/images/ico_service.svg"-->
<!--            />-->
<!--            <img v-else src="../assets/images/ico_customer.svg" />-->
<!--          </div>-->
          <div class="userName">{{ item.userNo }}</div>
          <div class="content">
            {{ item.msg }}
          </div></el-col
        >
      </el-row>
    </div>
    <div class="sending clearfix">
      <el-input
        v-model="message"
        type="textarea"
        :rows="3"
        resize="none"
        placeholder=""
      />
      <div class="text-right">
        <el-button @click="send" size="mini" type="primary">{{
          $t("onlineContact.send")
        }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    historyData: {
      type: Array,
    },
    businessNo: {
      type: String,
    },
    businessType: {
      type: String,
    },
    event: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      message: "",
      userName: "",
      msgList: [],
      sendUserNo: "",
    };
  },
  sockets: {
    connect: function () {
      console.log("socket connected");
    },
    disconnect: function () {
      console.log("socket disconnect");
    },
    push_event: function (data) {
      data = Array.isArray(data) ? JSON.parse(data[0]) : data;
      this.setMessage(data);
    },
  },
  watch: {
    historyData(value) {
      // this.msgList = value.concat(this.msgList);
      this.msgList = value;
    },
    visible(value) {
      if (value) {
        this.$socket.emit("userConnect", {
          businessNo: this.businessNo,
        });
      } else {
        this.msgList = [];
      }
    },
  },
  mounted() {
    this.userName = localStorage.getItem("ms_username");
    this.sendUserNo = this.userName;
  },
  methods: {
    modalClose() {
      this.$emit("update:visible", false); // 直接修改父组件的属性
    },
    send() {
      if (!this.message) {
        this.$message.warning(this.$t("onlineContact.tip"));
        return;
      }
      let msgData = {
        businessType: this.businessType,
        businessNo: this.businessNo,
        sendUserNo: this.sendUserNo,
        content: this.message,
      };

      this.$socket.emit("push_event", msgData);
      this.message = "";
      this.setMessage(msgData);
    },
    setMessage(data) {
      let pageData = {
        userNo: data.sendUserNo,
        msg: data.content,
      };
      this.msgList.push(pageData);
      this.$nextTick(() => {
        this.$refs.msgBox.scrollTop = this.$refs.msgBox.scrollHeight;
      });
    },
    onScroll() {
      if (this.$refs.msgBox.scrollTop == 0) {
        this.handleEvent(this.event);
      }
    },
    // 绑定的相关事件
    handleEvent(evnet, data) {
      this.$emit("handleEvent", evnet, data);
    },
    // 派发按钮点击事件
    handleClick(event, data) {
      this.$emit("handleClick", event, data);
    },
  },
};
</script>
<style lang="scss">
.onlineContact {
  .el-dialog__header {
    padding: 10px !important;
    background: #393d58;
    .el-dialog__title {
      color: #fff;
    }
    .el-dialog__headerbtn {
      top: 13px;
      color: #fff !important;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff !important;
    }
  }
  .el-dialog__body {
    padding: 0px 0px 6px !important;
  }
  .userHead {
    width: 34px;
    height: 34px;
    border: 1px solid #cedff3;
    border-radius: 20px;
    font-size: 12px;
    text-align: center;
    background: #e8f1fc;
    box-sizing: border-box;
    top: 16px;
    overflow: hidden;
    text-align: center;
  }
  .userHead img {
    width: 100%;
    text-align: center;
  }
  .userName {
    font-size: 12px;
    margin-bottom: 3px;
    color: #999;
    clear: both;
  }
  .content {
    padding: 4px 8px;
    font-size: 12px;
    border-radius: 4px;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
    clear: both;
  }
  .otherTxt {
    clear: both;
    padding: 10px 0 5px;
    position: relative;
    .content {
      background: #eee;
      float: left;
      margin-left: 38px;
    }
    .userHead {
      position: absolute;
      left: 0;
    }
    .userName {
      float: left;
      margin-left: 42px;
    }
  }
  .selfTxt {
    clear: both;
    padding: 10px 0 5px;
    position: relative;
    .content {
      background: #9eea6a;
      float: right;
      margin-right: 38px;
    }
    .userHead {
      position: absolute;
      right: 0;
    }
    .userName {
      float: right;
      margin-right: 42px;
    }
  }
  .chatLogs {
    height: 360px;
    box-sizing: border-box;
    overflow-y: auto;
    background: #f8f8f8;
    padding: 10px 15px;

    .loading {
      display: block;
      width: 100%;
      font-size: 20px;
      text-align: center;
    }
  }
  .sending {
    padding: 4px;
    textarea {
      padding: 4px 8px;
      border: none;
      margin: 0 0 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/onlineContact.vue